import React from 'react';

const Impressum = () => {
  return (
    <div className="bg-gray-800 min-h-screen flex flex-col items-center justify-center py-4">
      <div className="text-center">
        <h1 className='text-white text-4xl mb-4'>Impressum</h1>
        <p className='text-white text-lg'>Julian Gräfen</p>
        <p className='text-white text-lg'>Nordstraße 27</p>
        <p className='text-white text-lg'>53913 Swisttal</p>
      </div>
    </div>
  );
};

export default Impressum;
